(() => {
  const initAccountDrawer = () => {
    const drawer = document.getElementById('FAAccountDrawer');
    const triggerTemplate = document.getElementById('FAAccountTriggerTemplate');

    if (!drawer || !triggerTemplate) return;

    if (drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }

    document.querySelectorAll('shopify-account.header__icon').forEach((accountElement) => {
      const trigger = triggerTemplate.content.firstElementChild.cloneNode(true);
      accountElement.replaceWith(trigger);
    });

    const onboardingStorageKey = 'faAccountOnboarding';
    const onboardingMaxAge = 10 * 60 * 1000;
    const isSignedIn = drawer.dataset.faSignedIn === 'true';
    let lastFocusedElement = null;

    const getTriggers = () => document.querySelectorAll('[data-fa-account-open]');
    const getFocusableElements = () =>
      Array.from(
        drawer.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )
      ).filter((element) => !element.hasAttribute('hidden') && element.offsetParent !== null);

    const setTriggerState = (expanded) => {
      getTriggers().forEach((trigger) => trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false'));
    };

    const rememberAccountAction = (form) => {
      const formType = form.querySelector('input[name="form_type"]')?.value;
      if (!['customer_login', 'create_customer'].includes(formType)) return;

      try {
        sessionStorage.setItem(
          onboardingStorageKey,
          JSON.stringify({ type: formType, timestamp: Date.now() })
        );
      } catch (_) {
        // Browsers can block storage; authentication should still continue normally.
      }
    };

    const consumePendingOnboarding = () => {
      try {
        const raw = sessionStorage.getItem(onboardingStorageKey);
        if (!raw) return false;

        const pending = JSON.parse(raw);
        if (!pending?.timestamp || Date.now() - pending.timestamp > onboardingMaxAge) {
          sessionStorage.removeItem(onboardingStorageKey);
          return false;
        }

        if (!isSignedIn) return false;

        sessionStorage.removeItem(onboardingStorageKey);
        return true;
      } catch (_) {
        try {
          sessionStorage.removeItem(onboardingStorageKey);
        } catch (_) {
          // Ignore storage cleanup failures.
        }
        return false;
      }
    };

    const openDrawer = (event) => {
      if (event) {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
      }

      lastFocusedElement = document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('fa-account-drawer-open');
      document.body.classList.add('fa-account-drawer-open');
      setTriggerState(true);

      window.requestAnimationFrame(() => {
        const firstFocusable = getFocusableElements().find((element) => !element.matches('[data-fa-account-close].fa-account-drawer__overlay'));
        if (firstFocusable) firstFocusable.focus();
      });
    };

    const closeDrawer = () => {
      if (!drawer.classList.contains('is-open')) return;

      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('fa-account-drawer-open');
      document.body.classList.remove('fa-account-drawer-open');
      setTriggerState(false);

      if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
        lastFocusedElement.focus();
      }
    };

    document.addEventListener('submit', (event) => {
      if (event.target instanceof HTMLFormElement) {
        rememberAccountAction(event.target);
      }
    });

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-fa-account-open]');
      if (trigger) {
        openDrawer(event);
        return;
      }

      if (event.target.closest('[data-fa-account-close]')) {
        event.preventDefault();
        closeDrawer();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (!drawer.classList.contains('is-open')) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closeDrawer();
        return;
      }

      if (event.key !== 'Tab') return;

      const focusable = getFocusableElements();
      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    if (consumePendingOnboarding()) {
      window.requestAnimationFrame(() => openDrawer());
    } else if (drawer.querySelector('[data-fa-login-errors]')) {
      openDrawer();
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccountDrawer, { once: true });
  } else {
    initAccountDrawer();
  }
})();
